/**
 * Suppresses AbortError rejections — the normal, benign result of a
 * TanStack/Nostr query being cancelled after unmount/timeout. It returns
 * null so the caller gets a clean fallback, not a noisy unhandled
 * rejection.
 */
export async function queryAbortedOk<T>(eventPromise: Promise<T>, event: unknown): Promise<T | null> {
  try {
    return await eventPromise;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') return null;
    throw error;
  }
}
